import { Chip, type ChipSize } from '@/components/ui'
import type { ProjectStatus } from '../api/types'

/**
 * Module-scoped status chip for projects (Sprint 10).
 *
 * Mirrors `formulations/components/StatusChip.tsx` exactly — Project
 * status enum is identical to Formulation status (D-2), so the
 * tone-by-status mapping is identical too. Module-scoped because
 * nothing outside the projects module consumes this mapping today;
 * if a third consumer appears, hoist to a shared primitive.
 */

const VARIANT_BY_STATUS: Record<
  ProjectStatus,
  'neutral' | 'info' | 'success' | 'danger'
> = {
  draft: 'neutral',
  testing: 'info',
  approved: 'success',
  rejected: 'danger',
}

const LABEL_BY_STATUS: Record<ProjectStatus, string> = {
  draft: 'Draft',
  testing: 'Testing',
  approved: 'Approved',
  rejected: 'Rejected',
}

export interface ProjectStatusChipProps {
  status: ProjectStatus
  size?: ChipSize
}

export function ProjectStatusChip({ status, size = 'xs' }: ProjectStatusChipProps) {
  return (
    <Chip variant={VARIANT_BY_STATUS[status]} size={size} dot>
      {LABEL_BY_STATUS[status]}
    </Chip>
  )
}
